module.exports =  {

  whatIsLedgerDex: {
    title: "What Is LedgerDex?",
    contents: `
    <p>LedgerDex is the next generation crypto token manager and decentralized exchange that allows
      users to manage and trade Ethereum-based (ERC20) tokens.</p>
    <p>With LedgerDex's <strong>token manager</strong>, users can keep track of their token balance, send and receive ERC20 tokens.</p>
    <p>As a <strong>decentralized exchange</strong> built on top of the <a href="https://0xproject.com/" target="_blank" rel="nofollow"><strong>0x protocol</strong></a>, LedgerDex allows wallet-to-wallet trading of  ERC20 tokens.</p>
    `,
  },

  howDoesTradeWork: {
    title: "How Does Trading Work at LedgerDex?",
    contents: `
      <p>LedgerDex is a decentralized token exchange based on the
        <a href="https://www.0xproject.com/" target="_blank" rel="nofollow">0x protocol</a>,
         which "is an open, permissionless protocol allowing for ERC20 tokens to be traded
       on the Ethereum blockchain". </p>
      <p>All trades are executed by the 0x smart contract powered by the Ethereum blockchain.
      There is no need to deposit funds to the exchange or to the smart contract. Tokens
      are exchanged directly between traders' own wallets.</p>
      <p>To save Ethereum gas cost and increase efficiency, new orders are not stored on the
      Ethereum blockchain (therefore no gas cost). On-chain transactions only happen when a
      trade is executed.</p>
    `,
  },

  whatMakeUniqueAsExchange: {
    title: "What Makes LedgerDex Unique as an Exchange?",
    contents: `
    <p>LedgerDex is a decentralized token exchange that allows wallet-to-wallet trading with the following features:</p>
      <p><strong>Easy to Get Started, Eash to Use:</strong></p>
      <ul class="mb-2">
        <li>No need to sign up, just use your Ethereum account.</li>
        <li>No need to reveal your identity (no KYC).</li>
        <li>Log in and trade using the MetaMask browser extension.</li>
      </ul>
      <p><strong>Secure:</strong></p>
      <ul class="mb-2">
        <li>No need to deposit funds.</li>
        <li>Trade peer-to-peer right from your wallet.</li>
        <li>No need to worry about exchange being hacked or running away with your funds.</li>
      </ul>
      <p><strong>Reliable</strong></p>
      <ul class="mb-2">
        <li>Built on top of the 0x protocol, a reliable and leading standard for decentralized
        token exchange.</li>
        <li>Trades executed transparently by smart contract. No black box operations.</li>
      </ul>
    `,
  },

  howDifferentFromOtherERC20Exchanges: {
    title: "What Makes LedgerDex Different from Other ERC20 Token Exchanges?",
    contents: `
      <p>LedgerDex is different from centralized exchanges (such as Coinbase and Kraken)
       in that we <strong>don't hold your funds</strong> or ask you to send us money or tokens.
       Also, trades are executed by smart contracts. Everything is transparent and you
       don't have to worry about black box operations.</p>

      <p>LedgerDex is also different from other decentralized ERC20 token exchanges in that:
        1) Unlike some other decentralized exchanges, we don't store orders on the Ethereum blockchain
        so that you can save on gas fees. 2) Unlike other 0x-based exchanges
        where you can only trade a limited selection of tokens, LedgerDex
      <strong>allows users to add new trading pairs.</strong></p>
    `,
  },

  howToGetStarted: {
    title: "How to Get Started Using LedgerDex?",
    contents: `
      <p>Below are some basic requirements to use LedgerDex:</p>
      <ul class="mb-2">
        <li><strong>An Ethereum Account</strong>: you can open an Ethereum account using popular
        software or hardware wallets. Keep your private key safe and have it backed up.</li>
        <li><strong>The Metamask Browser Extension or a Mobile App With a dApp Browser</strong>:
          To use LedgerDex on a desktop computer, you need to use the
          <a href="https://metamask.io/" target="_blank" rel="nofollow">MetaMask</a> browser
          extension to sign your Ethereum transactions and log in LedgerDex. To use LedgerDex
          on a mobile phone, you need to use a compatible crypto wallet mobile app with a dApp browser,
          such as imToken.</li>
        <li><strong>Wrapping ETH to WETH for Trading</strong>: Currently ether (ETH) cannot
          be traded with other tokens directly. To trade, you need to wrap ETH (convert it)
          to the equivalent token WETH first. WETH is always 1:1 to ETH and can
          be converted back to ETH (called unwrapping) at any time. You can wrap/unwrap ETH at LedgerDex.</li>
        <li><strong>Setting Token Allowance for Trading</strong>: In order for the smart contract to execute your trades, you need to give it permission to access your tokens.
        This permission is called "allowance". You can set/remove token allowance at LedgerDex.</li>
      </ul>
    `,
  },

  whatCanBeDoneWithLedgerDex: {
    title: "What Can I Use LedgerDex for?",
    contents: `
      <p>Below are some possible ways to use LedgerDex:</p>
      <ul class="mb-2">
        <li><strong>Manage Your Tokens</strong>: Have too many tokens to keep track
        of? You can track all your ERC20 tokens in one-place at LedgerDex. You can see
        your token balances, send and receive tokens.</li>
        <li><strong>Trade Tokens for Profits</strong>: LedgerDex is a decentralized exchange. You
          can trade with other users and hopefully make some profits!</li>
        <li><strong>Peer-to-Peer Token Exchange</strong>: LedgerDex allows users to
          create "restricted orders", in which you can restrict on who can trade with you.
          If two people want to exchange tokens directly with each other, this feature will
          make the process secure and worry-free.</li>
        <li><strong>Buy or Sell Tokens Not Listed on Other Exchanges</strong>: LedgerDex allows users to add new token trading pairs by themselves. Therefore, You can use LedgerDex to buy or sell ERC20 tokens not listed on other exchanges.</li>
      </ul>
    `,
  },

  limitations: {
    title: "What Are the Limitations of LedgerDex?",
    contents: `
      <p>LedgerDex currently only supports Ethereum based (ERC20) tokens. Therefore, you
       can't manage or trade non-Ethereum cryptocurrencies such as Bitcoin, Litecoin and Ripple etc.</p>
      <p>Since trades are executed by smart contracts on the Ethereum blockchain,
        trading speed is limited by the speed of the Ethereum blockchain, which is
        currently not as fast as the trading speed at centralized exchanges.
      </p>
    `,
  },

}


